import React, { useRef } from 'react';
import { ErrorSmall } from '@wix/wix-ui-icons-common/on-stage';
import { Popover, PopoverTriggerAction, Text, TextButton } from '@wix/wix-ui-tpa/cssVars';
import { classes, st } from '../FileUpload.st.css';
import { DATA_HOOKS } from '../dataHooks';
import File from './File';
import { useTrapFocus } from './use-trap-focus';
import { useTranslation } from '../../../../../contexts/translation-context';
import { useFocusWhen } from './use-focus-when';
import { useId } from '../../../../../hooks/use-id';
import { useConfig } from '../../../../../contexts/config-context';
const fileKey = f => f.file.name;
const FileUploadPopover = _ref => {
  let {
    files,
    onDeleteClick,
    explanationText,
    hasError,
    setTextBelowButtonRef
  } = _ref;
  const [showFiles, setShowFiles] = React.useState(false);
  const {
    t
  } = useTranslation();
  const {
    isRTL: rtl
  } = useConfig();
  const contentId = useId();
  const contentRef = useRef(null);
  const textButtonRef = useRef(null);
  useFocusWhen(() => !showFiles, textButtonRef);
  useTrapFocus({
    active: showFiles,
    container: contentRef
  });
  const deleteButtonRefs = useRef({});
  return /*#__PURE__*/React.createElement(Popover, {
    appendTo: "parent",
    placement: rtl ? 'top-end' : 'top-start',
    onClickOutside: () => setShowFiles(false),
    shown: showFiles,
    className: classes.popover,
    triggerAction: PopoverTriggerAction.click,
    width: 280,
    onEscPress: () => {
      setShowFiles(false);
    },
    "aria-describedby": contentId,
    "aria-label": t('file-upload.popover.aria-label')
  }, /*#__PURE__*/React.createElement(Popover.Element, null, /*#__PURE__*/React.createElement(TextButton, {
    "data-hook": DATA_HOOKS.popoverButton,
    className: st(classes.multipleFileExplanation, {
      error: hasError
    }),
    onClick: () => setShowFiles(!showFiles),
    ref: ref => {
      textButtonRef.current = ref;
      setTextBelowButtonRef(ref);
    },
    "aria-haspopup": "dialog",
    "aria-expanded": showFiles,
    role: "region",
    "aria-live": "polite"
  }, explanationText)), /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement("div", {
    id: contentId,
    ref: contentRef,
    "data-hook": DATA_HOOKS.popoverContent,
    className: classes.files,
    role: "list"
  }, (files ?? []).map((file, index, allFiles) => /*#__PURE__*/React.createElement("div", {
    className: classes.multipleFiles,
    key: fileKey(file),
    "data-hook": DATA_HOOKS.popoverFile
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(File, {
    file: file,
    onDeleteClick: () => {
      const currentKey = fileKey(file);
      if (allFiles.length > 1) {
        var _firstFocusableElemen;
        const firstFocusableElement = allFiles.filter(f => fileKey(f) !== currentKey).map(f => deleteButtonRefs.current[fileKey(f)]).find(Boolean) ?? textButtonRef;
        (_firstFocusableElemen = firstFocusableElement.current) == null || _firstFocusableElemen.focus();
      }
      onDeleteClick == null || onDeleteClick(index);
    },
    dataHook: DATA_HOOKS.popoverFileName,
    "aria-describedby": `${fileKey(file)}-error`,
    role: "listitem",
    deleteButtonRef: deleteButtonRefs.current[fileKey(file)] ??= {
      current: null
    },
    focusFile: index === 0
  }), file.errorMessage && /*#__PURE__*/React.createElement("div", {
    className: classes.fileError,
    "data-hook": DATA_HOOKS.popoverFileError
  }, /*#__PURE__*/React.createElement(ErrorSmall, {
    className: classes.fileErrorIcon
  }), /*#__PURE__*/React.createElement(Text, {
    id: `${fileKey(file)}-error`,
    className: classes.filesErrorMessage
  }, file.errorMessage))))))));
};
export default FileUploadPopover;
//# sourceMappingURL=FileUploadPopover.js.map